import { ref, computed } from "vue";
import { defineStore } from "pinia";
import ru from "@/locales/ru.js";
import uz from "@/locales/uz.js";

const SUPPORTED = { ru, uz };
const LS_KEY = "pepsi_lang";
const BOT_LANG_KEY = "bot_lang";

export const useLangStore = defineStore("lang", () => {
	const botLang = localStorage.getItem(BOT_LANG_KEY);
	const savedLang = localStorage.getItem(LS_KEY);
	const initialLang = (SUPPORTED[botLang] ? botLang : null) || (SUPPORTED[savedLang] ? savedLang : null) || "ru";

	const lang = ref(initialLang);

	const t = computed(() => SUPPORTED[lang.value] || ru);

	const setLang = (code) => {
		if (!SUPPORTED[code]) return;
		lang.value = code;
		localStorage.setItem(LS_KEY, code);
	};

	const setBotLang = (code) => {
		if (!SUPPORTED[code]) return;
		localStorage.setItem(BOT_LANG_KEY, code);
		lang.value = code;
		localStorage.setItem(LS_KEY, code);
	};

	return { lang, t, setLang, setBotLang };
});
